import React, { useState, useEffect } from "react";
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import CustomDropdown from '../../../CustomControls/dropdownn';
import http from '../../../Services/HttpService';
import { Endpoints } from '../../../Global/Endpoints';
import { useSelector } from "react-redux";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import ErrorModal from '../../Security/ErrorModal';
import CustomDatePicker from '../../../CustomControls/CustomDatePicker';

const HealthLogMetrix_Fertility = () => {
  const [selectedDate, setSelectedDate] = useState(new Date());
  const navigate = useNavigate();
  const [form, setForm] = useState({
    Estradiol: '',
    FSH: '',
    LH: '',
    Progesterone: '',
    PregnancyHormone: '',
    AMH: '',
    AFC: '',
    OralMedication: '',
    OralMedicationDose: '',
    FollistimGonalF: '',
    MenopurDose: '',
    Leuprolide: '',
    TriggerShot: '',
    TriggerShotforOvulationDose: '',
    GanirelixCetrotide: '',
    EstradiolDose: '',
    ProgesteroneDose: '',
    BloodPressure: '',
    Glucose: '',
    Weight: '',
    TypeofWeight: 'kg', // default to kg
    shareData: false,
  });
  const userData = useSelector((state) => state.userData);
  const [modal, setModal] = useState({ show: false, message: '', isError: false });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const datePickerRef = React.useRef(null);

  const handleDateChange = (date) => {
    setSelectedDate(date);
    // Format date as MM/dd/yyyy string for form.SelectedDate
    const formatted = date ? `${(date.getMonth()+1).toString().padStart(2,'0')}/${date.getDate().toString().padStart(2,'0')}/${date.getFullYear()}` : '';
    setForm(prev => ({ ...prev, SelectedDate: formatted }));
    setErrors((prev) => ({ ...prev, selectedDate: undefined }));
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    // For BloodPressure, allow only numbers and one slash, and max 3 digits before/after slash, and no leading zeros
    if (name === 'BloodPressure') {
      // Remove all non-numeric and non-slash characters
      let cleaned = value.replace(/[^\d/]/g, '');
      // Only allow one slash
      const parts = cleaned.split('/');
      if (parts.length > 2) {
        cleaned = parts[0] + '/' + parts[1];
      }
      // Remove leading zeros from each part and limit to 3 digits
      if (parts.length === 1) {
        let left = parts[0].replace(/^0+/, '');
        cleaned = left.slice(0, 3);
      } else if (parts.length === 2) {
        let left = parts[0].replace(/^0+/, '');
        let right = parts[1].replace(/^0+/, '');
        cleaned = left.slice(0, 3) + '/' + right.slice(0, 3);
      }
      setForm((prev) => ({ ...prev, [name]: cleaned }));
      // Clear errors for valid blood pressure format
      if (/^[1-9]\d{0,2}\/[1-9]\d{0,2}$/.test(cleaned) || cleaned === '') {
        setErrors((prev) => ({ ...prev, BloodPressure: undefined }));
      }
      // Always check and clear 'form' error if any field is filled
      setTimeout(() => {
        const hasAnyField = Object.entries({ ...form, [name]: cleaned }).some(
          ([key, val]) =>
            key !== 'shareData' &&
            key !== 'SelectedDate' &&
            key !== 'TypeofWeight' &&
            val !== undefined &&
            val !== null &&
            val.toString().trim() !== ''
        );
        if (hasAnyField) {
          setErrors((prev) => ({ ...prev, form: undefined }));
        }
      }, 0);
      return;
    }
    // For all other fields except checkboxes, allow only numbers and one decimal point, max 6 characters
    // If placeholder is '0.0' allow decimals, if '0' allow only whole numbers
    const decimalFields = [
      'Estradiol', 'FSH', 'LH', 'Progesterone', 'PregnancyHormone', 'AMH',
      'OralMedicationDose', 'Leuprolide', 'GanirelixCetrotide',
      'EstradiolDose', 'ProgesteroneDose', 'Weight'
    ];
    // FollistimGonalF, MenopurDose, Glucose, AFC: only digits (whole numbers)
    const integerFields = ['AFC', 'FollistimGonalF', 'MenopurDose', 'Glucose'];
    if (decimalFields.includes(name)) {
      let cleaned = value.replace(/[^\d.]/g, '');
      // Only one decimal point
      const parts = cleaned.split('.');
      if (parts.length > 2) {
        cleaned = parts[0] + '.' + parts[1];
      }
      cleaned = cleaned.slice(0, 6);
      setForm((prev) => ({ ...prev, [name]: cleaned }));
      if (/^\d*\.?\d*$/.test(cleaned) || cleaned === '') {
        setErrors((prev) => ({ ...prev, [name]: undefined }));
      }
      setTimeout(() => {
        const hasAnyField = Object.entries({ ...form, [name]: cleaned }).some(
          ([key, val]) =>
            key !== 'shareData' &&
            key !== 'SelectedDate' &&
            key !== 'TypeofWeight' &&
            val !== undefined &&
            val !== null &&
            val.toString().trim() !== ''
        );
        if (hasAnyField) {
          setErrors((prev) => ({ ...prev, form: undefined }));
        }
      }, 0);
      return;
    }
    if (integerFields.includes(name)) {
      let cleaned = value.replace(/\D/g, '');
      cleaned = cleaned.slice(0, 6);
      setForm((prev) => ({ ...prev, [name]: cleaned }));
      if (/^\d*$/.test(cleaned) || cleaned === '') {
        setErrors((prev) => ({ ...prev, [name]: undefined }));
      }
      setTimeout(() => {
        const hasAnyField = Object.entries({ ...form, [name]: cleaned }).some(
          ([key, val]) =>
            key !== 'shareData' &&
            key !== 'SelectedDate' &&
            key !== 'TypeofWeight' &&
            val !== undefined &&
            val !== null &&
            val.toString().trim() !== ''
        );
        if (hasAnyField) {
          setErrors((prev) => ({ ...prev, form: undefined }));
        }
      }, 0);
      return;
    }
    if (name === 'OralMedicationDose' || name === 'TriggerShotforOvulationDose') {
      let cleaned = value.replace(/[^\d.]/g, '');
      const parts = cleaned.split('.');
      if (parts.length > 2) {
        cleaned = parts[0] + '.' + parts[1];
      }
      cleaned = cleaned.slice(0, 6);
      setForm((prev) => ({ ...prev, [name]: cleaned }));
      // Clear related errors if any field is now filled
      if (name === 'OralMedicationDose' && (cleaned || (!cleaned && !form.OralMedication))) {
        setErrors((prev) => ({ ...prev, OralMedication: undefined }));
      }
      if (name === 'TriggerShotforOvulationDose' && (cleaned || (!cleaned && !form.TriggerShot))) {
        setErrors((prev) => ({ ...prev, TriggerShot: undefined }));
      }
      setTimeout(() => {
        const hasAnyField = Object.entries({ ...form, [name]: cleaned }).some(
          ([key, val]) =>
            key !== 'shareData' &&
            key !== 'SelectedDate' &&
            key !== 'TypeofWeight' &&
            val !== undefined &&
            val !== null &&
            val.toString().trim() !== ''
        );
        if (hasAnyField) {
          setErrors((prev) => ({ ...prev, form: undefined }));
        }
      }, 0);
      return;
    }
    if (name === 'TriggerShot' || name === 'OralMedication') {
      let newForm = { ...form };
      if (name === 'TriggerShot') {
        newForm = { ...form, [name]: value, TriggerShotforOvulationDose: '' };
      } else if (name === 'OralMedication') {
        newForm = { ...form, [name]: value, OralMedicationDose: '' };
      }
      setForm(newForm);
      // Clear error if both dropdown and dose are filled or both are empty
      if (
        (name === 'TriggerShot' && ((value && form.TriggerShotforOvulationDose) || (!value && !form.TriggerShotforOvulationDose))) ||
        (name === 'OralMedication' && ((value && form.OralMedicationDose) || (!value && !form.OralMedicationDose)))
      ) {
        setErrors((prev) => ({ ...prev, [name === 'TriggerShot' ? 'TriggerShot' : 'OralMedication']: undefined }));
      } else if (!value) {
        setErrors((prev) => ({ ...prev, [name === 'TriggerShot' ? 'TriggerShot' : 'OralMedication']: undefined }));
      }
      // Always check and clear 'form' error if any field is filled
      setTimeout(() => {
        const hasAnyField = Object.entries({ ...newForm }).some(
          ([key, val]) =>
            key !== 'shareData' &&
            key !== 'SelectedDate' &&
            key !== 'TypeofWeight' &&
            val !== undefined &&
            val !== null &&
            val.toString().trim() !== ''
        );
        if (hasAnyField) {
          setErrors((prev) => ({ ...prev, form: undefined }));
        }
      }, 0);
      return;
    }
    if (
      name !== 'shareData' &&
      name !== 'SelectedDate' &&
      name !== 'TypeofWeight'
    ) {
      setForm((prev) => ({ ...prev, [name]: value }));
      // Clear 'Please fill at least one field.' error if any field is filled
      setTimeout(() => {
        const hasAnyField = Object.entries({ ...form, [name]: value }).some(
          ([key, val]) =>
            key !== 'shareData' &&
            key !== 'SelectedDate' &&
            key !== 'TypeofWeight' &&
            val !== undefined &&
            val !== null &&
            val.toString().trim() !== ''
        );
        if (hasAnyField) {
          setErrors((prev) => ({ ...prev, form: undefined }));
        }
      }, 0);
      return;
    }
    setForm((prev) => ({ ...prev, [name]: type === 'checkbox' ? checked : value }));
    // Clear errors for date
    if (name === 'selectedDate' && value) {
      setErrors((prev) => ({ ...prev, selectedDate: undefined }));
    }
  };

  const validate = () => {
    const newErrors = {};
    // Date is required
    if (!selectedDate || !form.SelectedDate) newErrors.selectedDate = 'Date is required.';
    // At least one other field (excluding shareData, SelectedDate, and TypeofWeight) must be filled
    const hasAnyField = Object.entries(form).some(
      ([key, value]) =>
        key !== 'shareData' &&
        key !== 'SelectedDate' &&
        key !== 'TypeofWeight' &&
        value !== undefined &&
        value !== null &&
        value.toString().trim() !== ''
    );
    if (!hasAnyField) newErrors.form = 'Please fill at least one field.';
    // Blood pressure validation (same as VitalsModal)
    if (form.BloodPressure && !/^[1-9]\d{1,2}\/[1-9]\d{1,2}$/.test(form.BloodPressure)) {
      newErrors.BloodPressure = 'Please enter blood pressure in format (e.g., 120/80)';
    }
    // Oral Medication validation: if OralMedicationDose is entered, OralMedication must be selected
    if (form.OralMedicationDose && !form.OralMedication) {
      newErrors.OralMedication = 'Please select an Oral Medication if you enter a dose.';
    }
    if (!form.OralMedicationDose && form.OralMedication) {
      newErrors.OralMedication = 'Please enter a dose.';
    }
    // Trigger Shot validation: if TriggerShotDose is entered, TriggerShot must be selected
    if (form.TriggerShotforOvulationDose && !form.TriggerShot) {
      newErrors.TriggerShot = 'Please select a Trigger Shot if you enter a dose.';
    }
    if (!form.TriggerShotforOvulationDose && form.TriggerShot) {
      newErrors.TriggerShot = 'Please enter a dose.';
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const updateConsent = async (checked) => {
    const emailId = userData?.userData?.EmailID;
    const token = localStorage.getItem("AccessToken");
    if (emailId) {
      const consentParams = {
        EmailID: emailId,
        Status: checked ? "Y" : "N",
        Contract: userData?.userData?.ContractIdentified || "",
      };
      try {
        const consentResponse = await axios.post(
          Endpoints.UpdatePregnancyDataConsent,
          `_Params=${encodeURIComponent(JSON.stringify(consentParams))}`,
          {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
              Authorization: `Bearer ${token}`,
            },
          }
        );
        if (consentResponse.status === 200) {
          // setModal({ show: true, message: checked ? "Consent enabled successfully." : "Consent disabled successfully.", isError: false });
        } else {
          setModal({ show: true, message: "Error updating consent.", isError: true });
        }
      } catch (error) {
        setModal({ show: true, message: "Error updating consent.", isError: true });
      }
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) {
      // If date is not selected, scroll to and focus the date picker input (do not open the picker)
      if (!selectedDate || !form.SelectedDate) {
        if (datePickerRef.current) {
          // Only scroll and focus the input, do not call setFocus (which opens the picker)
          if (datePickerRef.current.input) {
            datePickerRef.current.input.focus();
            datePickerRef.current.input.scrollIntoView({ behavior: 'smooth', block: 'center' });
          } else if (datePickerRef.current.scrollIntoView) {
            datePickerRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
        }
      }
      return;
    }
    setLoading(true);
    try {
      const appUserId = userData?.userData?.AppUserId  || "";
      // Use the formatted date from form.SelectedDate if available
      let formattedDate = form.SelectedDate;
      if (!formattedDate && selectedDate) {
        formattedDate = `${(selectedDate.getMonth()+1).toString().padStart(2,'0')}/${selectedDate.getDate().toString().padStart(2,'0')}/${selectedDate.getFullYear()}`;
      }
      const payload = {
        AppUserId: appUserId,
        SelectedDate: formattedDate,
        Estradiol: form.Estradiol,
        FollicleStimulatingHormone: form.FSH,
        LuteinizingHormone: form.LH,
        Progesterone: form.Progesterone,
        Pregnancyhormone: form.PregnancyHormone,
        Antimullerianhormone: form.AMH,
        Antralfolliclecount: form.AFC,
        OralMedicationDoseValue: form.OralMedicationDose,
        OralMedicationDose: form.OralMedication,
        FollistimGonalfDose: form.FollistimGonalF,
        MenopurDose: form.MenopurDose,
        LeuprolideDose: form.Leuprolide,
        TriggerShotforOvulation: form.TriggerShotforOvulationDose,
        TriggerShotforOvulationDose: form.TriggerShot,
        GanirelixCetrotideDose: form.GanirelixCetrotide,
        Estradioldose: form.EstradiolDose,
        ProgesteroneDose: form.ProgesteroneDose,
        BloodPressure: form.BloodPressure,
        Glucose: form.Glucose,
        Weight: form.Weight,
        TypeofWeight: form.TypeofWeight || "kg",
      };
      const token = localStorage.getItem("AccessToken");
      const response = await axios.post(
        Endpoints.SaveMiraDetails,
        `_Params=${encodeURIComponent(JSON.stringify(payload))}`,
        {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      debugger
      if (response && response.data && (response.data.result === 1)) {
        setModal({ show: true, message: response.data.resultText || 'Saved successfully!', isError: false });
        await updateConsent(form.shareData);
      } else {
        setModal({ show: true, message: response?.data?.Message || response?.data?.resultText || 'Error saving data. Please try again.', isError: true });
      }
    } catch (err) {
      setModal({ show: true, message: 'Error saving data. Please try again.', isError: true });
    } finally {
      setLoading(false);
    }
  };

  const handleBackClick = () => {
    navigate(-1);
  };

  const ssoData = useSelector((state) => state.sso.ssoUserData);
    const isHighmarkPortal = ssoData?.Portal === "Highmark";

  return (
    <div className="container my-5">
      <div className="col-md-12 mt-0 mb-4 d-flex inner-page-heading-wrapper">
      <button className="win-back-btn" onClick={handleBackClick}>
        <span>
          <i className="bi bi-chevron-left"></i>
          Back
        </span>
      </button>
      {isHighmarkPortal ? (
        <h2 className="page-headingg ms-2 mb-0">Health Log Metrix</h2>
      ) : (
        <h2 className="page-heading ms-2 mb-0">Health Log Metrix</h2>
      )}
    </div>
      <div className="card form-card p-4 mx-auto shadow-sm justify-content-center">
        <form onSubmit={handleSubmit}>
          <div className="mb-4">
            <label className="form-label">Select Date</label>
            <DatePicker
              ref={datePickerRef}
              selected={selectedDate}
              onChange={handleDateChange}
              dateFormat="MM/dd/yyyy"
              className={`form-control win-form-control-s calendar-control mobile-view ${errors.selectedDate ? "is-invalid" : ""}`}
              maxDate={new Date()}
              minDate={null}
              onKeyDown={e => e.preventDefault()}
              placeholderText="MM/DD/YYYY"
              value={form.SelectedDate || ''} // Bind input value to form.SelectedDate
            />
            {errors.selectedDate && <div className="text-danger small">{errors.selectedDate}</div>}
          </div>
          <h6 className="section-title mt-4 mb-3">Hormones</h6>
          <div className="row g-3">
            <div className="col-md-6">
              <label className="form-label">Estradiol (E2)</label>
              <input name="Estradiol" type="text" className="form-control win-form-control-a" placeholder="0.0 pg/mL" value={form.Estradiol} onChange={handleChange} />
            </div>
            <div className="col-md-6">
              <label className="form-label">Follicle Stimulating Hormone (FSH)</label>
              <input name="FSH" type="text" className="form-control win-form-control-a" placeholder="0.0 mIU/mL" value={form.FSH} onChange={handleChange} />
            </div>
            <div className="col-md-6">
              <label className="form-label">Luteinizing Hormone (LH)</label>
              <input name="LH" type="text" className="form-control win-form-control-a" placeholder="0.0 mIU/mL" value={form.LH} onChange={handleChange} />
            </div>
            <div className="col-md-6">
              <label className="form-label">Progesterone (P4)</label>
              <input name="Progesterone" type="text" className="form-control win-form-control-a" placeholder="0.0 ng/mL" value={form.Progesterone} onChange={handleChange} />
            </div>
            <div className="col-md-6">
              <label className="form-label">Pregnancy Hormone (HCG)</label>
              <input name="PregnancyHormone" type="text" className="form-control win-form-control-a" placeholder="0.0 mIU/mL" value={form.PregnancyHormone} onChange={handleChange} />
            </div>
            <div className="col-md-6">
              <label className="form-label">Anti-Müllerian Hormone (AMH)</label>
              <input name="AMH" type="text" className="form-control win-form-control-a" placeholder="0.0 ng/mL" value={form.AMH} onChange={handleChange} />
            </div>
            <div class="col-md-6">
              <label class="form-label">Antral Follicle Count (AFC)</label>
              <input name="AFC" type="number" class="form-control win-form-control-a" placeholder="0" value={form.AFC} onChange={handleChange} />
            </div>
          </div>
          <h6 className="section-title mt-4 mb-3">Medications</h6>
          <div className="row g-3">
            <div className="col-md-6">
              <label className="form-label ">Oral Medication</label>
              <CustomDropdown
                options={["Clomid", "Femara (Letrozole)", "Tamoxifen"]}
                selectedOption={form.OralMedication}
                onChange={val => setForm(prev => ({ ...prev, OralMedication: val, OralMedicationDose: '' }))}
                placeholder="Select Oral Medication"
                name="OralMedication"
              />
                <input
                  name="OralMedicationDose"
                  type="text"
                  className="form-control win-form-control-a mt-3"
                  placeholder={`Enter dose for ${form.OralMedication}`}
                  value={form.OralMedicationDose || ''}
                  onChange={e => {
                    handleChange(e);
                    // Clear OralMedication and form errors if any value is entered in any field
                    if (errors.OralMedication || errors.form) {
                      // Check if at least one field (excluding shareData, SelectedDate, TypeofWeight) is filled
                      const hasAnyField = Object.entries(form).some(
                        ([key, value]) =>
                          key !== 'shareData' &&
                          key !== 'SelectedDate' &&
                          key !== 'TypeofWeight' &&
                          value !== undefined &&
                          value !== null &&
                          value.toString().trim() !== ''
                      );
                      if (hasAnyField || e.target.value.trim() !== '') {
                        setErrors(prev => ({ ...prev, OralMedication: undefined, form: undefined }));
                      }
                    }
                  }}
                />
                {errors.OralMedication && <div className="text-danger small">{errors.OralMedication}</div>}
            </div>
            <div className="col-md-6">
              <label className="form-label">Follistim/Gonal-f</label>
              <input name="FollistimGonalF" type="text" className="form-control win-form-control-a" placeholder="0 IU" value={form.FollistimGonalF} onChange={handleChange} />
            </div>
            <div className="col-md-6">
              <label className="form-label">Menopur Dose</label>
              <input name="MenopurDose" type="text" className="form-control win-form-control-a" placeholder="0 IU" value={form.MenopurDose} onChange={handleChange} />
            </div>
            <div className="col-md-6">
              <label className="form-label">Leuprolide (Lupron)</label>
              <input name="Leuprolide" type="text" className="form-control win-form-control-a" placeholder="0.0 ng/mL" value={form.Leuprolide} onChange={handleChange} />
            </div>
            <div className="col-md-6">
              <label className="form-label">Trigger Shot For Ovulation</label>
              <CustomDropdown
                options={["HCG", "Pregnyl", "Novarel", "Ovidrel", "Lupron", "Mixed Lupron/HCG"]}
                selectedOption={form.TriggerShot}
                onChange={val => setForm(prev => ({ ...prev, TriggerShot: val, TriggerShotforOvulationDose: '' }))}
                placeholder="Select Trigger Shot"
                name="TriggerShot"
              />
              <input
                name="TriggerShotforOvulationDose"
                type="text"
                className="form-control win-form-control-a mt-3"
                placeholder={`Enter dose for ${form.TriggerShot}`}
                value={form.TriggerShotforOvulationDose || ''}
                onChange={handleChange}
              />
              {errors.TriggerShot && <div className="text-danger small">{errors.TriggerShot}</div>}
            </div>
            <div className="col-md-6">
              <label className="form-label">Ganirelix/Cetrotide</label>
              <input name="GanirelixCetrotide" type="text" className="form-control win-form-control-a" placeholder="0.0 mcg" value={form.GanirelixCetrotide} onChange={handleChange} />
            </div>
            <div className="col-md-6">
              <label className="form-label">Estradiol</label>
              <input name="EstradiolDose" type="text" className="form-control win-form-control-a" placeholder="0.0 mg" value={form.EstradiolDose} onChange={handleChange} />
            </div>
            <div className="col-md-6">
              <label className="form-label">Progesterone</label>
              <input name="ProgesteroneDose" type="text" className="form-control win-form-control-a" placeholder="0.0 mg" value={form.ProgesteroneDose} onChange={handleChange} />
            </div>
          </div>
          <h6 className="section-title mt-4 mb-3">Vital Signs</h6>
          <div className="row g-3">
            <div className="col-md-6">
              <label className="form-label">Blood Pressure</label>
              <input name="BloodPressure" type="text" className="form-control win-form-control-a" placeholder="0.0/0.0" value={form.BloodPressure} onChange={handleChange} />
              {errors.BloodPressure && <div className="text-danger small">{errors.BloodPressure}</div>}
            </div>
            <div className="col-md-6">
              <label className="form-label">Glucose</label>
              <input name="Glucose" type="text" className="form-control win-form-control-a" placeholder="0 mg/dL" value={form.Glucose} onChange={handleChange} maxLength={3} />
            </div>
            <div className="col-md-6">
              <label className="form-label">Weight</label>
              <div className="input-group">
                <input
                  name="Weight"
                  type="text"
                  className="form-control win-form-control-a"
                  placeholder="0.0"
                  value={form.Weight}
                  onChange={handleChange}
                  maxLength={3}
                />
                {/* Toggle style updated to match VitalsModal (unit-button style, not Bootstrap) */}
                <div className="ms-2 d-flex">
                  <button
                    type="button"
                    className={form.TypeofWeight === "kg" || !form.TypeofWeight ? "unit-button me-2 active" : "unit-button me-2 inactive"}
                    onClick={() => setForm(prev => ({ ...prev, TypeofWeight: "kg" }))}
                  >
                    kg
                  </button>
                  <button
                    type="button"
                    className={form.TypeofWeight === "lbs" ? "unit-button active" : "unit-button inactive"}
                    onClick={() => setForm(prev => ({ ...prev, TypeofWeight: "lbs" }))}
                  >
                    lbs
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="d-flex align-items-center mt-4">
            <div className="form-check form-switch me-2">
              <input className="form-check-input" type="checkbox" id="shareData" name="shareData" checked={form.shareData} onChange={e => setForm(prev => ({ ...prev, shareData: e.target.checked }))} />
            </div>
            <label htmlFor="shareData" className="small text-muted">
              I agree to share my data with nurses at WIN to assist and guide me through my journey.
            </label>
          </div>
          {errors.form && <div className="text-danger small mt-2 text-left">{errors.form}</div>}

          <div className="d-flex justify-content-end gap-2 mt-4 flex-wrap">
            <button
              type="button"
              className="win-btn-secondary model-popup-btn"
              onClick={() => navigate('/fertility-trends')}
            >
              See Trends
            </button>
            <button type="submit" className="win-btn-primary model-popup-btn">Save</button>
          </div>
        </form>
      </div>
      {loading && (
        <div className="loading-container">
          <div className="loading"></div>
          {/* <h2 className="loading-text">Loading...</h2> */}
        </div>
      )}
      <ErrorModal
        show={modal.show}
        message={modal.message}
        isOkay={true}
        onOkay={() => setModal({ ...modal, show: false })}
        onClose={() => setModal({ ...modal, show: false })}
      />
    </div>
  );
};

export default HealthLogMetrix_Fertility;
